import type { AnyItem, MonospacePrimitiveField } from '#layers/data-model';
import type { ResolvedMonospacePrimitiveField, ResolvedMonospaceSingleRelationField } from '#layers/data-model/types/schema/resolved-schema';
import { pick } from '#layers/base/utils/object';

export function pickByPrimitiveFields(item: AnyItem, fields: MonospacePrimitiveField[] | ResolvedMonospacePrimitiveField[]) {
	return pick(item, fields.map((field) => field.apiName));
}

export function getItemFieldValue<T = any>(
	item: AnyItem | undefined | null,
	field?: ResolvedMonospacePrimitiveField | ResolvedMonospaceSingleRelationField | null,
): T | null {
	if (!item || !field) return null;
	return (item[field.apiName] as T) ?? null;
}
